import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=a60dbb56&scoped=true&"
import script from "./Consult.vue?vue&type=script&lang=js&"
export * from "./Consult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60dbb56",
  null
  
)

export default component.exports